import { Skeleton, styled } from "@mui/material";
import MediaFile from "./MediaFile";
import { LoaderOverlay } from "components";

const ContainerStyled = styled("div")({
  width: "100%",
  padding: "1rem 0 2.5rem",
  display: "flex",
  alignItems: "flex-start",
  gap: "0.5rem",
  overflow: "auto",
  "& .media-file": {
    width: "170px",
    flexShrink: 0,
    "& .file-container": {
      height: "120px",
    },
  },
});

const AddingNewPlaceholder = styled("div")({
  position: "relative",
});

const MediaLibrary = ({
  mediaFiles = [],
  className,
  isAddingNew,
  loadingId,
  onSaveChanges,
  onDelete,
}) => {
  return (
    <ContainerStyled className={className}>
      {isAddingNew && (
        <AddingNewPlaceholder>
          <Skeleton variant="rounded" width={170} height={120} />
          <LoaderOverlay withoutBackground />
        </AddingNewPlaceholder>
      )}
      {mediaFiles.map((file) => (
        <MediaFile
          key={file.id}
          file={file}
          className="media-file"
          onSaveChanges={onSaveChanges}
          onDelete={onDelete}
        />
      ))}
    </ContainerStyled>
  );
};

const MediaLibrarySkeleton = ({ total = 3, className }) => {
  return (
    <ContainerStyled className={className}>
      {Array.from({ length: total }, (_, index) => (
        <Skeleton key={index} variant="rounded" width={170} height={120} />
      ))}
    </ContainerStyled>
  );
};

MediaLibrary.Skeleton = MediaLibrarySkeleton;

export default MediaLibrary;
